import type { ApiResponse } from "./api-response"

const errorMessageFromBody = (
  body: ApiResponse<unknown> & { detail?: unknown },
  status: number,
): string => {
  if (body.detail != null && typeof body.detail === "string") {
    return body.detail
  }
  return body.message ?? `Request failed with status ${status}`
}

export const parseResponse = async <T>(res: Response): Promise<T> => {
  // Guard non-JSON error bodies (proxy 502/504 HTML, empty payloads) so the
  // detail/message extraction below still runs instead of throwing a SyntaxError.
  const body = (await res.json().catch(() => ({}))) as ApiResponse<T>

  if (!res.ok || !body.success) {
    throw new Error(errorMessageFromBody(body, res.status))
  }

  if (body.data === undefined) {
    throw new Error("No data in response")
  }

  return body.data
}

/** Success envelope without requiring `data` (e.g. DELETE with empty or null payload). */
export const parseSuccessResponse = async (res: Response): Promise<void> => {
  if (res.status === 204) return

  const body = (await res.json().catch(() => ({}))) as ApiResponse<unknown>

  if (!res.ok || !body.success) {
    throw new Error(errorMessageFromBody(body, res.status))
  }
}
